import React from 'react'
import './Footer.css'
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaLinkedin,
  FaDribbble,
  FaBehance,
    
  } from "react-icons/fa";



function Footer() {
    return (
        <footer id="contact">

        <div className="footer_container">

        <div className='social_icons'>
            <Link
              className='social_icon_link'
              to={'//www.behance.net/akibsheikh'}
              target='_blank'
              aria_label='BEHANCE'
            >
              <FaBehance />
            </Link>
            <Link
              className='social_icon_link'
              to={'//www.instagram.com/akibsheikh1/'}
              target='_blank'
              aria_label='Instagram'
            >
              <FaInstagram/>
            </Link>
            <Link
              className='social_icon_link'
              to={
                '//dribbble.com/akibsheikh'
              }
              target='_blank'
              aria_label='DERRIBLE'
            >
              <FaDribbble />
            </Link>
           
            <Link
              className='social_icon_link'
              to={'//www.linkedin.com/in/akib-sheikh-bb5a17190'}
              target='_blank'
              aria_label='LinkedIn'
            >
              <FaLinkedin />
            </Link>
          </div>
          <ul className="copyright">
              <h6>&copy; Copyright 2020 Akib Sheikh - Design by Akib Sheikh</h6>
              
           </ul>
           {/* <div className="twelve columns">
              <ul className="social-links">
               
                 <Link
                className="social_icon_link"
                to={"//www.github.com/Akibsheikh48"}
                target="_blank"
                aria_label="Facebook"
              >
                <FaGithub />
              </Link>
              <Link
                className="social_icon_link"
                to={"//www.instagram.com/akibsheikh1/?igshid=1n35acwkvzx00"}
                target="_blank"
                aria_label="Instagram"
              >
                <FaInstagram />
              </Link>
              <Link
                className="social_icon_link"
                to={
                  "//www.youtube.com/channel/UC3rtUUwsd09W6yZ6dkR8Wmw?view_as=subscriber"
                }
                target="_blank"
                aria_label="Youtube"
              >
                <FaYoutube />
              </Link>
              <Link
                className="social_icon_link"
                to={"//WWW.twitter.com/akibsheikh48?s=03"}
                target="_blank"
                aria_label="Twitter"
              >
                <FaTwitter />
              </Link>
              <Link
                className="social_icon_link"
                to="//www.linkedin.com/in/akib-sheikh-bb5a17190"
                target="_blank"
                aria_label="LinkedIn"
              >
                <FaLinkedin />
              </Link>
              </ul>
   
              <ul>
               <li>Modified with love by the Clever Programmer team ♥️</li>
              </ul>
   
              <ul className="copyright">
                 <li>&copy; All credit goes to Tim Baker - Copyright 2017 Tim Baker</li>
                 <li>Design by <a title="Styleshout" href="http://www.styleshout.com/">Styleshout</a></li>
              </ul>
   
           </div> */}
           {/* <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"><FaChevronCircleUp/></i></a></div> */}
        </div>
     </footer>
    )
}

export default Footer
